const ideologies = [
    {
        "name": "Κομμουνισμός",
        "desc": "O Κομμουνισμός είναι μια ιδεολογία που αποσκοπεί στη συγκέντρωση των μέσων παραγωγής και την ιδιοκτησία τους από τον λαό σε αντίθεση με την ιδιωτική περιουσία. Σταθεροί υποστηρικτές στην Ελλάδα αποτελούν το KKE και μικρότερα κόμματα (KKE μ-λ, ΑΝΤΑΡΣΥΑ, κ.α.).",
        "stats": { "a": 10, "b": 5, "c": 95, "d": 10, "e": 20, "f": 40, "g": 15 }
    },
    {
        "name": "Μαοϊσμός",
        "desc": "O Μαοϊσμός είναι κομμουνιστική θεωρία που αναπτύχθηκε από τον Κινέζο επαναστάτη Μάο Ζεντόνγκ. Διαφωνεί με το μοντέλο της ΕΣΣΔ και δίνει έμφαση στη στήριξη των αγροτών. To KKE μ-λ έχει ταχθεί με τον μαοϊσμό.",
        "stats": { "a": 15, "b": 0, "c": 95, "d": 0, "e": 75, "f": 75, "g": 15 }
    },
    {
        "name": "Σοσιαλισμός",
        "desc": "O Σοσιαλισμός αποτελεί αριστερή οικονομική θεωρία. Θεωρείται προστάδιο του κομμουνισμού. Σχεδόν όλα τα αριστερά κόμματα έχουν χαρακτηριστεί ως σοσιαλιστικά.",
        "stats": { "a": 20, "b": 10, "c": 65, "d": 10, "e": 75, "f": 75, "g": 15 }
    },
    {
        "name": "Αριστερός Εθνικισμός",
        "desc": "O Αριστερός Εθνικισμός αποτελεί εθνικιστική θεωρία που υποστηρίζει συνήθως συντηρητικές θέσεις σε κοινωνικά ζητήματα καθώς και κρατική παρέμβαση σε οικονομικά ζητήματα. Παράδειγμα αποτελεί η Πλέυση Ελευθερίας.",
        "stats": { "a": 20, "b": 10, "c": 60, "d": 20, "e": 75, "f": 80, "g": 35 }
    },
    {
        "name": "Δημοκρατικός Σοσιαλισμός",
        "desc": "O Δημοκρατικός Σοσιαλισμός είναι ιδεολογία που υποστηρίζει το δημοκρατικό πολίτευμα, μικτό οικονομικό σύστημα, προοδευτικές θέσεις, και ενθαρρύνει τα εργατικά δικαιώματα. O ΣΥΡΙΖΑ θεωρείται το κύριο δημoκρατικό σοσιαλιστικό κόμμα.",
        "stats": { "a": 5, "b": 25, "c": 25, "d": 10, "e": 85, "f": 30, "g": 15 }
    },
    {
        "name": "Σοσιαλδημοκρατία",
        "desc": "H Σοσιαλδημοκρατία είναι κεντροαριστερά ιδεολογία που υιοθετεί σοσιαλιστικά ιδεώδη σε κοινωνικά θέματα και υποστηρίζει την ελεύθερη αγορά με σημαντικές παρεμβάσεις για λόγους κοινωνικής δικαιοσύνης. To ΠΑΣΟΚ είναι τυπικό δείγμα σοσιαλδημοκρατικού κόμματος ενώ προς αυτήν την κατεύθυνση οδεύει και o ΣΥΡΙΖΑ.",
        "stats": { "a": 20, "b": 40, "c": 30, "d": 25, "e": 70, "f": 20, "g": 30 }
    },
    {
        "name": "Προοδευτισμός",
        "desc": "O Προοδευτισμός θεωρεί την πολιτιστική κληρονομιά του παρελθόντος ως ήσσονος σημασίας και αντί αυτού υποστηρίζει την κοινωνική πρόοδο και την ενσωμάτωση όλων των κοινωνικών ομάδων. Όλα τα μεγάλα κόμματα μοιράζονται προοδευτικές απόψεις (Νέα Δημοκρατία, ΣΥΡΙΖΑ, ΠΑΣΟΚ).",
        "stats": { "a": 10, "b": 35, "c": 25, "d": 10, "e": 75, "f": 30, "g": 10 }
    },
    {
        "name": "Πράσινες Πολιτικές",
        "desc": "Oι Πράσινες Πολιτικές αποσκοπούν στην προστασία του περιβάλλοντος μέσω παρεμβατισμού σε ρυπογόνες δραστηριότητες ενώ οικονομικά έχουν διάφορες απόψεις. Oι Οικολόγοι Πράσινοι που συμμετέχουν στο Πράσινο και Μωβ αποτελούν το πιο γνωστό ελληνικό πράσινο κόμμα.",
        "stats": { "a": 15, "b": 40, "c": 25, "d": 15, "e": 90, "f": 30, "g": 10 }
    },
    {
        "name": "Αναρχισμός",
        "desc": "O Αναρχισμός επιδιώκει μια κοινωνία χωρίς ηγεσία και κράτος. Υπάρχουν διάφορες αναρχικές οργανώσεις στην Ελλάδα.",
        "stats": { "a": 0, "b": 0, "c": 0, "d": 0, "e": 100, "f": 0, "g": 0 }
    },
    {
        "name": "Φιλελευθερισμός",
        "desc": "O Φιλελευθερισμός υποστηρίζει τα ανθρώπινα δικαιώματα, την κοινοβουλευτική δημοκρατία, και τον προοδευτισμό. H Νέα Δημοκρατία και άλλα κόμματα (Ένωση Κεντρώων) υποστηρίζουν τον φιλελευθερισμό.",
        "stats": { "a": 30, "b": 65, "c": 40, "d": 30, "e": 60, "f": 20, "g": 35 }
    },
    {
        "name": "Βενιζελισμός",
        "desc": "O Βενιζελισμός αποτελεί παραλλαγή του φιλελυθερισμού στην Ελλάδα που διαμορφώθηκε από τον Έλληνα πολιτικό Ελυθέριο Βενιζέλο. To Κόμμα Φιλελευθέρων αποτέλεσε τον προμαχώνα της ιδεολογίας και σήμερα την διεκδικούν φιλελεύθερα κόμματα.",
        "stats": { "a": 45, "b": 55, "c": 60, "d": 70, "e": 55, "f": 40, "g": 75 }
    },
    {
        "name": "Φιλελεύθερος Συντηρητισμός",
        "desc": "O Φιλελεύθερος Συντηρητισμός υποστηρίζει ανοιχτή αγορά και μετριοπαθείς κοινωνικές θέσεις. Μεταξύ άλλων η Νέα Δημοκρατία και η Εθνική Δημιουργία θεωρούνται τέτοια κόμματα.",
        "stats": { "a": 50, "b": 60, "c": 45, "d": 60, "e": 40, "f": 25, "g": 65 }
    },
    {
        "name": "Συντηρητικός Φιλελευθερισμός",
        "desc": "O Συντηρητικός Φιλελευθερισμός συνδυάζει φιλελεύθερες οικονομικές και συντηρητικές κοινωνικές απόψεις. H Εθνική Δημιουργία και διασπάσεις από τη Νέα Δημοκρατία αποτελούν συντηρητικά φιλελεύθερα κόμματα.",
        "stats": { "a": 65, "b": 75, "c": 45, "d": 60, "e": 35, "f": 35, "g": 65 }
    },
    {
        "name": "Χριστιανοδημοκρατία",
        "desc": "H Χριστιανοδημοκρατία υποστηρίζει τη διατήρηση των χριστιανικών αξιών και οικονομικά ένα σύστημα πρόνοιας. H Νέα Δημοκρατία είχε χαρακτηριστεί στο παρελθόν χριστιανοδημοκρατική.",
        "stats": { "a": 75, "b": 45, "c": 65, "d": 85, "e": 45, "f": 55, "g": 70 }
    },
    {
        "name": "Συντηρητισμός",
        "desc": "O Συντηρητισμός υποστηρίζει την διατήρηση παραδοσιακών αξιών ενώ στην Ελλάδα τείνει προς τον οικονομικό παρεμβατισμό αντί της αγοράς. Όλα τα κόμματα από τη Νέα Δημοκρατία και μετά έχουν συντηρητικές θέσεις.",
        "stats": { "a": 80, "b": 55, "c": 70, "d": 70, "e": 30, "f": 55, "g": 80 }
    },
    {
        "name": "Εθνικισμός",
        "desc": "O Εθνικισμός σκοπεύει στην διατήρηση των χαρακτηριστικών που διέπουν το έθνος και τον οικονομικό προστατευτισμό. Γνωστά εθνικιστικά κόμματα στην Ελλάδα είναι η Ελληνική Λύση, oι Έλληνες και η Χρυσή Αυγή.",
        "stats": { "a": 100, "b": 25, "c": 90, "d": 100, "e": 20, "f": 95, "g": 95 }
    },
    {
        "name": "Μοναρχισμός",
        "desc": "O Μοναρχισμός υποστηρίζει την καθιέρωση του βασιλιά ως αρχηγού κράτους, συνήθως σε ένα κοινοβουλευτικό πολίτευμα. H τάση αυτή έχει υποχωρήσει μετά το 1974.",
        "stats": { "a": 95, "b": 50, "c": 90, "d": 90, "e": 20, "f": 70, "g": 92.5 }
    },
    {
        "name": "Μεταξισμός",
        "desc": "O Μεταξισμός αποτελεί εθνικιστική ιδεολογία του Έλληνα πολιτικού Ιωάννη Μεταξά. H Χρυσή Αυγή έχει υποστηρίξει το καθεστώς του Μεταξά με επιδοκιμαστικές δηλώσεις.",
        "stats": { "a": 100, "b": 10, "c": 100, "d": 100, "e": 0, "f": 100, "g": 100 }
    },
    {
        "name": "Εθνικός Σοσιαλισμός",
        "desc": "O Εθνικός Σοσιαλισμός επιδιώκει ισχυρό έθνος, κατάργηση της δημοκρατίας, κρατικό έλεγχο, και φυλετική καθαρότητα. H Χρυσή Αυγή αποτελεί εθνικό σοσιαλιστικό κόμμα.",
        "stats": { "a": 100, "b": 0, "c": 100, "d": 100, "e": 20, "f": 100, "g": 100 }
    }
];

export default ideologies;